import { Component } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { PDFDocument } from 'pdf-lib';
import html2canvas from 'html2canvas';

interface QrItem {
  value: string;
  account: string;
  phone: string;
  deviceCode: string;
  fullName: string;
  background: string;
  qrType: string;
}

@Component({
  selector: 'app-qr-generate',
  templateUrl: './qr-generate.component.html',
  styleUrls: ['./qr-generate.component.scss']
})
export class QrGenerateComponent {
  accountNumber = '';
  phoneNumber = '';
  deviceCode = '';
  fullName = '';

  backgroundTemp: string | null = 'with-bg';   
  qrTypeTemp: string | null = 'with-name';     
  quantityTemp: number | null = null;        



  qrList: QrItem[] = [];

  constructor(private apiService: ApiService) {}

generateQR(): void {
  if (!this.accountNumber?.trim() || !this.phoneNumber?.trim() || !this.deviceCode?.trim()) {
    this.apiService.showToast(
      'Thông báo',
      'Vui lòng nhập đầy đủ Số tài khoản, Số điện thoại và Mã thiết bị',
      'error'
    );
    return;
  }

  if (!this.quantityTemp || this.quantityTemp <= 0) {
    this.apiService.showToast('Thông báo', 'Vui lòng chọn số lượng QR', 'error');
    return;
  }

  const payload = {
    serial_number: this.deviceCode.trim(),
    account_number: this.accountNumber.trim(),
    phone: this.phoneNumber.trim()
  };

  this.apiService.postItem('devices/get-qrstring-info', payload).subscribe({
    next: (res: any) => {
      const meta = res?.metadata;
      if (!meta?.qr_string) {
        this.apiService.showToast('Thông báo', 'Không nhận được dữ liệu QR từ API', 'error');
        return;
      }

      this.qrList = Array.from({ length: this.quantityTemp }, () => ({
        value     : meta.qr_string,
        account   : meta.account_number,
        phone     : meta.phone,
        deviceCode: meta.serial_number,
        fullName  : meta.account_name,
        background: this.backgroundTemp || 'with-bg',
        qrType    : this.qrTypeTemp || 'no-name'
      }));
    },
    error: (err) => {
      const msg = err || 'Lỗi khi gọi API lấy QR';
      this.apiService.showToast('Thông báo', msg, 'error');
    }
  });
}

onlyNumberInput(event: KeyboardEvent) {
  const charCode = event.charCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}

filterAlphaNumeric(event: any) {
  const input = event.target as HTMLInputElement;
  input.value = input.value.replace(/[^a-zA-Z0-9]/g, '');
  this.deviceCode = input.value;
}

 async exportPDF(): Promise<void> {
  const element = document.getElementById('pdf-content');

  if (!element) {
    console.error('Không tìm thấy vùng export PDF (#pdf-content)');
    return;
  }

  try {
    await new Promise(resolve => setTimeout(resolve, 300));

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#ffffff',
      scrollX: 0,
      scrollY: -window.scrollY
    });

    const imgData = canvas.toDataURL('image/png');

    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage();

    const pngImage = await pdfDoc.embedPng(imgData);

    const pageWidth = page.getWidth();
    const pageHeight = page.getHeight();

    const imgWidth = pngImage.width;
    const imgHeight = pngImage.height;

    const scale = Math.min(
      pageWidth / imgWidth,
      pageHeight / imgHeight
    );

    const drawWidth = imgWidth * scale;
    const drawHeight = imgHeight * scale;

    page.drawImage(pngImage, {
      x: (pageWidth - drawWidth) / 2,
      y: pageHeight - drawHeight - 20,
      width: drawWidth,
      height: drawHeight
    });

    const pdfBytes = await pdfDoc.save();

    const safeBytes = new Uint8Array(pdfBytes.length);
    safeBytes.set(pdfBytes);

    const blob = new Blob([safeBytes], { type: 'application/pdf' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'qr-code.pdf';
    link.click();

    URL.revokeObjectURL(link.href);

  } catch (err) {
    console.error('Lỗi export PDF:', err);
  }
}

}
